<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import { stripNonNumeric, formatForInputField } from "@/functions/numbers";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix, modifierAction } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'polygon', isCutout ) );
const modifiers = computed(() => store.getters.getModifiers( isCutout ));
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => formatForInputField(dimensions.value["width"]),
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const sideAmount = computed({
	get: () => formatForInputField(modifiers.value["side_amount"]),
	set: (value: string) => {
		store.commit(modifierAction, {
			modifier: "side_amount",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="polygon-width"
			:id="`${prefix}measurements-polygon-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width', 'polygon')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}polygon-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'polygon')"
			v-model="width"
		/>
		<dimension-input
			inputRef="polygon-side_amount"
			:id="`${prefix}measurements-polygon-side_amount`"
			:name="`${prefix}measurements[modifiers][side_amount]`"
			:inputmode="'numeric'"
			:type="'number'"
			:min="3"
			:max="30"
			:step="1"
			:label="dimensionLabel('side_amount', 'polygon')"
			:instructions="isCutout ? '' : dimensionMaxLabel('side_amount')"
			:invalid="!isDimensionValid(`${prefix}polygon-side_amount`)"
			:onBlur="() => addSizeToDataLayer('side_amount', +sideAmount, 'polygon')"
			v-model="sideAmount"
		/>
	</shape-input-fields-wrapper>
</template>
